"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidColor = void 0;
var FluidColor;
(function (FluidColor) {
    FluidColor["BLUE"] = "blue";
    FluidColor["YELLOW"] = "yellow";
    FluidColor["ORANGE"] = "orange";
    FluidColor["RED_ORANGE"] = "red-orange";
    FluidColor["DEEP_YELLOW"] = "deep-yellow";
    FluidColor["INFO"] = "info";
    FluidColor["WARNING"] = "warning";
    FluidColor["ERROR"] = "error";
    FluidColor["WHITE"] = "white";
    FluidColor["OPAQUE"] = "opaque";
    FluidColor["GRAY"] = "gray";
    FluidColor["LIGHT_GRAY"] = "light-gray";
    FluidColor["SUCCESS"] = "success";
})(FluidColor = exports.FluidColor || (exports.FluidColor = {}));
